/* import __COLOCATED_TEMPLATE__ from './metric-card.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Args {
  icon: InterfaceIconName;
  iconClass?: string;
  title: string;
  description?: string;
  tooltip?: string;
  padding?: 'compact';
  tooltipArticleTitle?: string;
  tooltipArticleId?: number;
  tooltipArticleAnalyticsObject?: string;
  articleTitle?: string;
  articleId?: number;
  articleAnalyticsObject?: string;
  analyticsPlace?: string;
}

interface Signature {
  Element: any;
  Args: Args;
}

export default class MetricCard extends Component<Signature> {
  @service declare intercomEventService: any;

  private showArticleWithTracking(
    event: MouseEvent,
    objectName: string | undefined,
    articleId: number | undefined,
  ): void {
    event.preventDefault();
    event.stopPropagation();

    if (objectName) {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'clicked',
        object: objectName,
        place: this.args.analyticsPlace ?? '',
        context: 'metric_card',
      });
    }

    window.Intercom('showArticle', articleId);
  }

  @action showTooltipArticle(event: MouseEvent) {
    this.showArticleWithTracking(
      event,
      this.args.tooltipArticleAnalyticsObject,
      this.args.tooltipArticleId,
    );
  }

  @action showArticle(event: MouseEvent) {
    this.showArticleWithTracking(event, this.args.articleAnalyticsObject, this.args.articleId);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Signup::Teams::Pricing5::Components::MetricCard': typeof MetricCard;
  }
}
